import { useContext, useEffect, useState } from "react";
import { isEmpty } from "lodash";
import { useSelector } from "react-redux";
import {
  Alert,
  Badge,
  Card,
  CardBody,
  CardHeader,
  FormGroup,
  Modal,
  ModalBody,
} from "reactstrap";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useRef } from "react";

import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import Icon from "./../../../components/Icon/Icon";
import Button from "./../../../components/Button/Button";
import EmptyData from "./../../../helpers/EmptyData/EmptyData";
import DateTimePicker from "./../../../components/DateTimePicker/DateTimePicker";
import InfoItem from "./../../../helpers/InfoItem/InfoItem";
import Tooltip from "./../../../components/Tooltip/Tooltip";
import ErrorMessage from "./../../../helpers/ErrorMessage/ErrorMessage";
import Currency, {
  ConvertCurrency,
} from "./../../../helpers/Currency/Currency";
import { flightUserContext } from "../../../context/UserContext/FlightUserContext/FlightUserContext";
import { Block } from "../../../components/Block/Block";
import {
  charter724GenderTypeItems,
  charter724NationalityCodeItems,
  charter724NationalityItems,
  charter724PassengerTypeItems,
  convertCharter724AirlineToLogo,
  convertCharter724AirlineToText,
  convertCharter724FlightTypeToText,
  convertCharter724GenderTypeToText,
  convertCharter724PassengerTypeToText,
} from "../../../utils/enum";
import { convertDate, calculateDuration } from "../../../utils";
import { reservationCharter724Validation } from "../../../utils/validation/validation";
import { Col, Row } from "./../../../components/Grid/Grid";
import {
  DataTable,
  DataTableBody,
  DataTableHead,
  DataTableItem,
  DataTableRow,
} from "../../../components/DataTable/DataTable";
import { toastErrorMessage } from "../../../utils/toastMessage/toastMessage";
import FAQSection from "../../../components/FAQSection/FAQSection";
import Banners from "../../../components/Banners/Banners";
import { Nav, NavItem, NavLink } from "reactstrap";
import moment from "jalali-moment";
import Select from "react-select";
import FlightDetailsModal from "./FlightDetailsModal";

const FlightsUser = () => {
  const loader = useSelector((state) => state.loader);

  const {
    flights,
    originItem,
    setOriginItem,
    avail15Days,
    setAvail15Days,
    destinationItem,
    setDestinationItem,
    originFilter,
    setOriginFilter,
    destinationFilter,
    setDestinationFilter,
    date,
    setDate,
    showOriginItems,
    setShowOriginItems,
    showDestinationItems,
    setShowDestinationItems,
    handleGetAirportList,
    handleGetAvailable,
    handleGetCaptcha,
    handleGetAvailable15Days,
  } = useContext(flightUserContext);

  useEffect(() => {
    handleGetAirportList();
  }, []);

  useEffect(() => {
    if (originItem?.iatA_airport && destinationItem?.iatA_airport)
      handleGetAvailable15Days();
  }, [originItem?.iatA_airport, destinationItem?.iatA_airport]);

  useEffect(() => {
    const handleClick = (e) => {
      if (document.getElementById("originSearchBox")?.contains(e.target)) {
        setShowOriginItems(true);
        setAvail15Days([]);
        setOriginItem({});
      } else {
        setShowOriginItems(false);
      }
    };

    window.addEventListener("click", handleClick);
    return () => window.removeEventListener("click", handleClick);
  }, []);

  useEffect(() => {
    const handleClick = (e) => {
      if (document.getElementById("destinationSearchBox")?.contains(e.target)) {
        setShowDestinationItems(true);
        setAvail15Days([]);
        setDestinationItem({});
      } else {
        setShowDestinationItems(false);
      }
    };

    window.addEventListener("click", handleClick);
    return () => window.removeEventListener("click", handleClick);
  }, []);

  // Tabs
  const [activeTab, setActivetab] = useState("tAbout");
  const toggle = (tab) => { setActivetab(tab) };

  // change page ui  
  const [isSearch, setisSearch] = useState(false)
  const savedEventRef = useRef(null); // Ref to store the event object

  function handleSubmit(e) {
    e.preventDefault();
    savedEventRef.current = e;
    setisSearch(true)
    handleGetAvailable(e)
  }

  // next/prev date button
  useEffect(() => {
    if (isSearch) {
      handleGetAvailable(savedEventRef.current);
    }
  }, [date]);

  const dateBtnAction = (type) => {
    if (!savedEventRef.current) {
      console.error('No saved event to modify');
      return;
    }

    const currentMoment = moment(date);
    let newDate;

    if (type === 'forward') {
      newDate = currentMoment.add(1, 'days').toDate();
    } else if (type === 'back') {
      newDate = currentMoment.subtract(1, 'days').toDate();
    }

    setDate(newDate);

    // Modify the date value in the saved event object
    savedEventRef.current.target[3].value = moment(newDate).format('YYYY/MM/DD');
  }

  // sort and filters
  const sortList = [
    { label: 'بیشترین قیمت', value: 'highest' },
    { label: 'کمترین قیمت', value: 'lowest' },
    { label: 'جدیدترین', value: 'new' },
    { label: 'قدیمی ترین', value: 'old' },
  ]
  const [sort, setSort] = useState({ label: '', value: '' })
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen((prev) => !prev);
  const handleSelectChange = (e) => {
    setSort(e);
    toggleMenu();

    // complete with sort logic
    handleSort('highest')
  }

  const handleSort = (type) => { }


  // new modals
  const [detailModalOpen, setDetailModalOpen] = useState(false)
  const [selectedFlight, setSelectedFlight] = useState({})
  const toggleDetailModal = () => setDetailModalOpen((open) => !open)
  const handleDetailsModal = (item) => {
    setSelectedFlight(item)
    toggleDetailModal()
  }

  return (
    <>
      <SiteTitle title="پرواز ها" />
      <div className="container">

        {/* -- ---- -- --- Page Header --- -- ---- -- */}

        <div className="w-100 d-flex mb-5">
          <div className="bg-orange-dim p-1 rounded-pill d-flex p-2" style={{ width: 56, height: 56 }}>
            <img src="/assets/images/logos/fly.png" alt="fly" />
          </div>
          <div className="flex-grow-1 px-3 justify-around flex-column">
            <p className="text-soft">خدمات گردشگری /<span className="fw-bold text-dark"> پرواز</span></p>
            {/* {!isEmpty(hotels) ? ( */}
            {/* <h4> نتایج جستجو برای {selectedItem.fa_title}</h4> */}
            {/* ) : */}
            <h4 className="mt-n4">پرواز</h4>
            {/* } */}
          </div>
        </div>

        {!isSearch &&
          <Card>
            {/* ---- ---- --- >> Tabs << --- ---- ---- */}
            <div className="border-bottom border-top-0 border-left-0 border-right-0">
              <Nav tabs className="px-3">
                <NavItem className="w-50 d-flex">
                  <NavLink
                    tag='a'
                    className="w-100 justify-center"
                    href="#tab"
                    active={activeTab === "tOne"}
                    onClick={(ev) => {
                      ev.preventDefault();
                      toggle("tOne");
                    }}
                  >
                    یک طرفه
                  </NavLink>
                </NavItem>
                <NavItem className="w-50 d-flex" disabled>
                  <NavLink
                    tag='a'
                    href="#tab"
                    className="w-100 justify-center"
                    active={activeTab === "tTwo"}
                    onClick={(ev) => {
                      ev.preventDefault();
                      toggle("tTwo");
                    }}
                    disabled //temporary
                  >
                    دو طرفه (غیرفعال)
                  </NavLink>
                </NavItem>
              </Nav>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="d-flex flex-wrap flex-md-nowrap justify-center align-center mt-2 mx-md-2">
                <div className="w-100 center d-flex flex-column align-center justify-center mb-2 position-relative">
                  <div className="w-100 center">
                    <div id="originSearchBox" className=" mb-2 h-100 w-90 bg-gray-dim rounded-pill border px-4 py-1"
                      style={{ maxHeight: '64px' }}
                    >
                      <div className="row align-items-center">
                        <div>
                          <Icon name="map-pin-fill" className="fa-2x px-1" />
                        </div>
                        <div className="col">
                          <div>
                            <label
                              className="m-0 text-muted fs-14px"
                              htmlFor="origin"
                            >
                              جستجوی شهر مبدا
                            </label>
                            {isEmpty(originItem) ? (
                              <input
                                autoComplete="off"
                                autoFocus
                                type="text"
                                id="origin"
                                value={originFilter}
                                placeholder="مبدا سفر"
                                className="form-control border-0 shadow-none text-dark fw-bold p-0 bg-transparent"
                                onChange={(e) => setOriginFilter(e.target.value)}
                              />
                            ) : (
                              <div>
                                <input
                                  type="text"
                                  value={originItem.name_fa}
                                  className="form-control border-0 shadow-none text-dark fw-bold p-0 bg-transparent"
                                  readOnly
                                />
                              </div>
                            )}
                          </div>
                          <Airports
                            filter={originFilter}
                            setSelectedItem={setOriginItem}
                            setShowSearchItems={setShowOriginItems}
                            showSearchItems={showOriginItems}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* -- -- >> Reverse Button << -- -- */}
                  <div className="pos-abs cursor-pointer bg-white rounded-pill p-1 center shadow-sm"
                    style={{ left: '12%' }}
                    onClick={() => {
                      setOriginItem(destinationItem)
                      setDestinationItem(originItem)
                    }}
                  >
                    <Icon name="swap-v" className="fa-2x" />
                  </div>
                  {/* -- -- >> Reverse Button End << -- -- */}
                  <div className="w-100 center">
                    <div id="destinationSearchBox" className="h-100 w-90 bg-gray-dim rounded-pill border px-4 py-1"
                      style={{ maxHeight: '64px' }}
                    >
                      <div className="row align-items-center">
                        <div>
                          <Icon name="map-pin" className="fa-2x px-1" />
                        </div>
                        <div className="col">
                          <div>
                            <label
                              className="m-0 text-muted fs-14px"
                              htmlFor="destination"
                            >
                              جستجوی شهر مقصد
                            </label>
                            {isEmpty(destinationItem) ? (
                              <input
                                autoComplete="off"
                                type="text"
                                id="destination"
                                value={destinationFilter}
                                placeholder="مقصد سفر"
                                className="form-control border-0 shadow-none text-dark fw-bold p-0 bg-transparent"
                                onChange={(e) => setDestinationFilter(e.target.value)}
                              />
                            ) : (
                              <div>
                                <input
                                  type="text"
                                  value={destinationItem.name_fa}
                                  className="form-control border-0 shadow-none text-dark fw-bold p-0 bg-transparent"
                                  readOnly
                                />
                              </div>
                            )}
                          </div>
                          <Airports
                            filter={destinationFilter}
                            setSelectedItem={setDestinationItem}
                            setShowSearchItems={setShowDestinationItems}
                            showSearchItems={showDestinationItems}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="w-100 center d-flex flex-column align-center justify-center mb-2">
                  <div className="w-100 center">
                    <div className="mb-2 h-100 w-90 bg-gray-dim rounded-pill border px-4 py-1"
                      style={{ maxHeight: '64px' }}
                    >
                      <div className="row align-items-center">
                        <div>
                          <Icon name="calender-date" className="fa-2x px-1" />
                        </div>
                        <div className="col">
                          <label className="m-0 text-muted fs-14px" htmlFor="date">
                            تاریخ سفر
                          </label>
                          <DateTimePicker
                            id="date"
                            className="form-control border-0 shadow-none text-dark fw-bold p-0 bg-transparent"
                            placeholder="تاریخ سفر را وارد نمایید"
                            initValue={date}
                            onChange={setDate}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="w-80 center">
                    <Button
                      type="submit"
                      className="btn-block h-100 py-3 py-md-3 rounded-pill bg-orange text-white fw-light"
                      size="lg"
                      color="orange"
                      loading={loader}
                    >
                      جستجوی پرواز
                    </Button>
                  </div>
                </div>
              </div>

              {activeTab === 'tTwo' && <div className="col-12 col-md-6 col-lg-4 px-3 mb-2">
                <div className="bg-gray-dim rounded-pill border px-4 py-1 h-100">
                  <div className="row align-items-center">
                    <div>
                      <Icon name="calender-date" className="fa-2x px-1" />
                    </div>
                    <div className="col">
                      <label className="m-0 text-muted fs-14px" htmlFor="date">
                        2 تاریخ سفر
                      </label>
                      <DateTimePicker
                        id="date"
                        className="form-control bg-transparent form-control-lg border-0 shadow-none"
                        placeholder="تاریخ سفر را وارد نمایید"
                        initValue={date}
                        onChange={setDate}
                      />
                    </div>
                  </div>
                </div>
              </div>}

            </form>
          </Card>
        }
        {/* -- -- >> Date Button << -- -- */}
        {!isEmpty(flights) && isSearch && (
          <Card>
            <div className='justify-between p-2'>
              <div className='p-2 rounded-xl center cursor-pointer'
                style={{ background: '#F9F9F9' }}
                onClick={() => dateBtnAction('back')}
              >
                <Icon name="chevron-left" className="fa-2x" />
              </div>
              <div className='center flex-column w-50'>
                <p className="fs-15px fw-bold m-0">{moment(date).locale('fa').format('jD jMMM jYYYY')}</p>
                <div className="d-flex text-center align-center fs-13px"
                  style={{ gap: '10px' }}
                >
                  <p className="m-0">مبدا</p>
                  <img src="/assets/images/icons/flight-airplane.svg" alt='airplane' height='18px' />
                  <p>مقصد</p>
                </div>
              </div>
              <div className='p-2 rounded-xl center cursor-pointer'
                style={{ background: '#F9F9F9' }}
                onClick={() => dateBtnAction('forward')}
              >
                <Icon name="chevron-right" className="fa-2x" />
              </div>
            </div>
          </Card>
        )}

        {/* -- -- >> Date Button End << -- -- */}


        {/* -- -- >> Sort and Filters << -- -- */}
        {(isEmpty(flights) && isSearch) ? (
          <></>
        ) : isSearch && (
          <div className="mt-3 d-flex justify-between items-center mx-3">
            <div className="d-flex" style={{ gap: '6px' }}>
              <div className="d-flex text-muted fs-12px" style={{ gap: '4px' }}>
                <Icon name="filter-alt" className="fs-17px" />
                <p>مرتب سازی</p>
              </div>
              <div className="position-relative d-flex">

                <div className="d-flex center fs-12px fw-bold cursor-pointer"
                  style={{ gap: "5px", zIndex: '2', userSelect: 'none' }}
                  onClick={toggleMenu}
                >
                  <p className="m-0">{!sort.label ? 'بر اساس' : sort.label}</p>
                  <Icon name="downward-ios" className="fs-15px" />
                </div>
                <div className="form-control-wrap pos-abs" style={{ width: '120px', top: '-15px' }}>
                  <Select
                    noOptionsMessage={() => <span>داده ای برای نمایش یافت نشد</span>}
                    className="react-select-container fs-12px"
                    classNamePrefix="react-select"
                    menuIsOpen={isMenuOpen}
                    options={sortList}
                    value={'lowest'}
                    onChange={handleSelectChange}
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        border: '0 !important',
                        visibility: 'hidden'
                      }),
                      container: (baseStyles, state) => ({
                        ...baseStyles,
                        background: 'transparent',
                      }),
                      input: (baseStyles, state) => ({
                        ...baseStyles,
                        visibility: 'hidden'
                      }),
                      valueContainer: (baseStyles, state) => ({
                        ...baseStyles,
                        visibility: 'hidden'
                      }),
                      indicatorsContainer: (baseStyles, state) => ({
                        visibility: 'hidden'
                      }),
                    }}
                  />
                </div>
              </div>

            </div>
            <div className="d-flex fs-12px" style={{ gap: '6px' }}>
              <Icon name="filter" className="fs-19px text-muted" />
              <p className="m-0">فیلتر نتایج</p>
            </div>
          </div>
        )}
        {/* -- -- >> Sort and Filters End << -- -- */}


        <Block className="mt-3 mb-4">
          {(isEmpty(flights) && isSearch) ? (
            <EmptyData />
          ) : isSearch && (
            <>
              {flights?.map((item) => (
                <Card className="mb-2">
                  <CardBody>
                    <div className="py-1">
                      <div className="justify-between align-center">
                        <div className="d-flex text-nowrap center" style={{ gap: '6px' }}>
                          <img
                            src={convertCharter724AirlineToLogo(item.airline)}
                            alt={convertCharter724AirlineToText(item.airline)}
                            title={convertCharter724AirlineToText(item.airline)}
                            loading="lazy"
                            className="rounded-pill"
                            style={{ height: 40, width: "100%", objectFit: 'cover' }}
                          />
                          <p className="m-0 fs-12px">
                            {convertCharter724AirlineToText(item.airline)}
                          </p>
                        </div>
                        <div className="d-flex" style={{ gap: '6px' }}>
                          <div className="border rounded-pill px-1 center" style={{ gap: '5px' }}>
                            {/* <Icon name="briefcase" className="fs-17px" style={{ marginBottom: '2px' }} /> */}
                            <p className="m-0 fs-11px center">{convertCharter724FlightTypeToText(item.type)}</p>
                          </div>
                          <div className="border rounded-pill px-1 center fs-11px">{item.displayLable}</div>
                          <div className="border rounded-pill px-1 center fs-11px">{item.carrier}</div>
                        </div>
                      </div>

                      <p className="mt-1 fs-12px fw-bold">شماره پرواز: {item.number_flight}</p>

                      {/* Flight Details */}
                      <div className="mt-4">
                        <div className="w-100 justify-between align-center">
                          {/* <p className="m-0">{convertDate(item.date_flight)}</p> */}
                          <p className="m-0">{convertDate(`2000/01/01 ${item.time_flight}`, "HH:mm")}</p>
                          {/* <p className="m-0">{convertDate(item.date_flight)}</p> */}
                          <div></div>
                        </div>

                        <div className="w-100 justify-between align-center fw-bold fs-18px">
                          <p className="m-0">{item.from}</p>
                          <div className="w-60 bg-red center d-flex">
                            <div className="w-30"
                              style={{ border: '2px dashed rgba(233, 232, 233, 1)', borderLeft: 'none', borderRight: 'none', borderBottom: 'none' }}
                            ></div>
                            <img src="/assets/images/icons/flight-airplane-circle.svg" alt='airplane' />
                            <div className="w-30"
                              style={{ border: '2px dashed rgba(233, 232, 233, 1)', borderLeft: 'none', borderRight: 'none', borderBottom: 'none' }}
                            ></div>
                          </div>
                          <p>{item.to}</p>
                        </div>

                        <div className="w-100 justify-center">
                          <p className="text-muted m-0">{convertDate(item.date_flight)}</p>
                          {/* <p className="text-muted">{convertDate(`2000/01/01 ${item.time_flight}`, "HH:mm")}</p> */}
                          {/* <p>{calculateDuration(`2000/01/01 ${item.time_flight}`, `2000/01/01 20:45:00`)}</p> */}
                          {/* <p>{convertDate(`2000/01/01 20:45:00`, "HH:mm")}</p> */}
                        </div>
                      </div>
                      {/* Flight Details End */}
                    </div>

                    <div className="d-flex justify-between align-bottom w-100 mt-3">
                        <Button
                          color="orange"
                          // size="lg"
                          className='py-2 px-4 rounded-xl bg-orange text-white fs-14px fw-light text-nowrap'
                          disabled={item.capacity <= 0}
                          // onClick={() => handleGetCaptcha(item)}
                          onClick={() => handleDetailsModal(item)}
                        >
                          انتخاب پرواز
                        </Button>

                      <div className="d-flex flex-column justify-end">
                        {/* <p className="text-d-line m-0">4980000</p> */}
                        <p className="fw-bold d-flex flex-row-reverse" style={{ gap: '4px' }}>
                          <span className="text-muted fw-light fs-12px">ريال</span>
                          <ConvertCurrency
                            price={Math.floor(item.price_final / 10)}
                          />
                          <span className="fw-normal text-nowrap fs-12px">قیمت بزرگسال</span>
                        </p>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              ))}
              <div className="mt-4">
                <Button
                  color="primary"
                  size="lg"
                  className='rounded-xl text-white w-100 p-3 center fw-light'
                  onClick={() => setisSearch(false)}
                >
                  بازگشت
                </Button>
              </div>
            </>
          )}

        </Block>

        {/* {!isEmpty(avail15Days) &&
          originItem?.iatA_airport &&
          destinationItem?.iatA_airport && (
            <>
              <hr />
              <Card>
                <CardHeader>بهترین قیمت در روز های آینده</CardHeader>
                <div style={{ overflowX: "auto" }} className="d-flex">
                  {avail15Days?.map((item) => (
                    <Card
                      key={item.ajency_online_ID}
                      className="col-8 col-sm-6 col-md-4 col-lg-3 p-2 m-2 text-center cursor-pointer shadow"
                      onClick={() => setDate(item.date_flight)}
                    >
                      <div>
                        {convertDate(item.date_flight, "dddd - DD MMM")}
                      </div>
                      <hr />
                      <div className="d-flex align-items-center justify-content-center">
                        {item.discount > 0 && (
                          <div className="mx-1">
                            <Badge color="danger">
                              % {item.discount} تخفیف
                            </Badge>
                          </div>
                        )}
                        <div>
                          <ConvertCurrency
                            price={Math.floor(item.price_final / 10)}
                          />
                        </div>
                        <div className="mx-1">
                          <Currency />
                        </div>
                      </div>
                    </Card>
                  ))}
                </div>
              </Card>
              <hr />
            </>
          )} */}
        <Banners />

        <FAQSection />
      </div>

      <FlightDetailsModal open={detailModalOpen} toggle={toggleDetailModal} item={selectedFlight} />
      <Reservation />
    </>
  );
};

export default FlightsUser;

const Airports = ({
  filter,
  showSearchItems,
  setShowSearchItems,
  setSelectedItem,
}) => {
  const { airports } = useContext(flightUserContext);

  if (isEmpty(airports) || !showSearchItems) return null;

  const filteredAirports = airports?.filter(
    (s) =>
      s?.name_en?.toLowerCase()?.match(filter?.toLowerCase()) ||
      s?.name_fa?.toLowerCase()?.match(filter?.toLowerCase()) ||
      s?.iatA_airport?.toLowerCase()?.match(filter?.toLowerCase())
  );

  return (
    <div
      className="position-absolute bg-white border rounded overflow-auto cursor-pointer"
      style={{ maxHeight: 300, width: "100%", zIndex: 10 }}
    >
      {filteredAirports?.map((item) => (
        <div
          key={item.code_int}
          onClick={() => {
            setSelectedItem(item);
            setShowSearchItems(false);
          }}
          className="d-flex align-items-center justify-content-center py-2 border-bottom"
        >
          <div className="col-2">
            <Icon name="location" className="fa-2x" />
          </div>
          <div className="col">
            <h6>{item.name_fa}</h6>
            <span className="text-muted">{item.name_en}</span>
          </div>
        </div>
      ))}
    </div>
  );
};
const Reservation = () => {
  const loader = useSelector((state) => state.loader);
  const user = useSelector((state) => state.user);

  // Validation
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(reservationCharter724Validation),
  });

  const { flight, setFlight, handleReservation } =
    useContext(flightUserContext);

  const handleCloseModal = () => {
    setFlight({});
    reset();
  };

  const handleAddPassenger = (pasType) => {
    const passengers = watch("passengers") ?? [];

    if (passengers.length >= flight.capacity)
      return toastErrorMessage(
        "تعداد مسافران نمیتواند بیشتر از ظرفیت پرواز باشد"
      );

    let price = flight.price_final;

    switch (pasType) {
      case charter724PassengerTypeItems[0]:
        price = flight.price_final;
        break;
      case charter724PassengerTypeItems[1]:
        price = flight.price_final_chd;
        break;
      case charter724PassengerTypeItems[2]:
        price = flight.price_final_inf;
        const adl = passengers.filter(
          (p) => p.passengerType === charter724PassengerTypeItems[0]
        )?.length;
        const inf = passengers.filter(
          (p) => p.passengerType === charter724PassengerTypeItems[2]
        )?.length;
        if (inf >= adl)
          return toastErrorMessage(
            "تعداد مسافران نوزاد نمی تواند از بزگسالان بیشتر باشد"
          );
        break;

      default:
        break;
    }
    const initialPassenger = {
      passengerType: pasType,
      fnamefa: "",
      lnamefa: "",
      fnameen: "",
      lnameen: "",
      price: Math.floor(price / 10),
      gender: charter724GenderTypeItems[0],
      nationality: charter724NationalityItems[0],
      passengerCode: "",
      nationalitycode: charter724NationalityCodeItems[0],
      expdate: "",
      birthday: "",
    };

    setValue("passengers", [...passengers, initialPassenger]);
  };
  const handleRemovePassenger = (index) =>
    setValue(
      "passengers",
      watch("passengers")?.filter((_, _i) => _i !== index)
    );

  useEffect(() => {
    if (!isEmpty(flight)) {
      handleAddPassenger(charter724PassengerTypeItems[0]);
      setValue("email", user.email);
      setValue("mobile", user.phoneNumber);
    }
  }, [flight]);

  return (
    <Modal
      isOpen={!isEmpty(flight)}
      toggle={handleCloseModal}
      className="modal-dialog-centered"
      size="xl"
    >
      <ModalBody>
        <span type="button" onClick={handleCloseModal} className="close">
          <Icon name="cross-sm" />
        </span>
        <form
          className="is-alter p-2"
          autoComplete="off"
          onSubmit={handleSubmit(handleReservation)}
        >
          <h5 className="title">اطلاعات رزرو</h5>
          <br />
          <span className="text-primary border-bottom fw-bold">
            اطلاعات پرواز
          </span>
          <Row>
            <Col sm="6" md="4">
              <InfoItem title="تاریخ">
                {convertDate(flight?.date_flight, "YYYY-MM-DD")}
              </InfoItem>
            </Col>
            <Col sm="6" md="4">
              <InfoItem title="روز">
                {convertDate(flight?.date_flight, "dddd")}
              </InfoItem>
            </Col>
            <Col sm="6" md="4">
              <InfoItem title="ساعت">{flight?.time_flight}</InfoItem>
            </Col>
            <Col sm="6" md="4">
              <InfoItem title="مبدا">{flight?.from}</InfoItem>
            </Col>
            <Col sm="6" md="4">
              <InfoItem title="مقصد">{flight?.to}</InfoItem>
            </Col>
            <Col sm="6" md="4">
              <InfoItem title="ایرلاین">
                {convertCharter724AirlineToText(flight?.airline)}
              </InfoItem>
            </Col>
          </Row>

          <br />
          <span className="text-primary border-bottom fw-bold">مسافران</span>

          <div>
            <div className="data-head my-3">
              <div className="form-control-wrap">
                <input type="hidden" className="form-control" />
                <ErrorMessage message={errors.passengers?.message} />
              </div>
              <h6 className="overline-title">مسافران</h6>
            </div>

            {charter724PassengerTypeItems.map((item) => (
              <Button
                key={item}
                outline={item !== charter724PassengerTypeItems[0]}
                type="button"
                onClick={() => handleAddPassenger(item)}
                color="primary"
                className="mb-2 mr-2"
              >
                افزودن {convertCharter724PassengerTypeToText(item)}
              </Button>
            ))}

            <DataTable className="card-stretch">
              <DataTableBody className="overflow-auto">
                <DataTableHead>
                  <DataTableRow>
                    <span className="sub-text">#</span>
                  </DataTableRow>
                  <DataTableRow>
                    <span className="sub-text">رده سنی</span>
                  </DataTableRow>
                  <DataTableRow>
                    <span className="sub-text">جنسیت</span>
                  </DataTableRow>
                  {/* <DataTableRow>
                    <span className="sub-text">نام فارسی</span>
                  </DataTableRow>
                  <DataTableRow>
                    <span className="sub-text">نام خانوادگی فارسی</span>
                  </DataTableRow> */}
                  <DataTableRow>
                    <span className="sub-text">نام لاتین</span>
                  </DataTableRow>
                  <DataTableRow>
                    <span className="sub-text">نام خانوادگی لاتین</span>
                  </DataTableRow>
                  <DataTableRow>
                    <span className="sub-text">کد ملی / پاسپورت</span>
                  </DataTableRow>
                  <DataTableRow>
                    <span className="sub-text">
                      قیمت <Currency />
                    </span>
                  </DataTableRow>
                  <DataTableRow />
                </DataTableHead>
                {/*Head*/}
                {!isEmpty(watch("passengers")) &&
                  watch("passengers")?.map((_item, index) => (
                    <DataTableItem key={_item._id}>
                      <DataTableRow>
                        <span>{index + 1}</span>
                      </DataTableRow>
                      <DataTableRow>
                        <span>
                          {convertCharter724PassengerTypeToText(
                            _item.passengerType
                          )}
                        </span>
                      </DataTableRow>
                      <DataTableRow style={{ width: 100 }}>
                        <div className="form-control-wrap">
                          <select
                            {...register(`passengers[${index}].gender`)}
                            className="form-control-lg form-control"
                          >
                            {charter724GenderTypeItems.map((item) => (
                              <option value={item} key={item}>
                                {convertCharter724GenderTypeToText(item)}
                              </option>
                            ))}
                          </select>
                          <ErrorMessage
                            message={
                              errors.passengers &&
                              errors.passengers[index]?.gender?.message
                            }
                          />
                        </div>
                      </DataTableRow>
                      {/* <DataTableRow>
                        <div className="form-control-wrap">
                          <input
                            type="text"
                            className="form-control-lg form-control"
                            {...register(`passengers[${index}].fnamefa`)}
                          />
                          <ErrorMessage
                            message={
                              errors.passengers &&
                              errors.passengers[index]?.fnamefa?.message
                            }
                          />
                        </div>
                      </DataTableRow>
                      <DataTableRow>
                        <div className="form-control-wrap">
                          <input
                            type="text"
                            className="form-control-lg form-control"
                            {...register(`passengers[${index}].lnamefa`)}
                          />
                          <ErrorMessage
                            message={
                              errors.passengers &&
                              errors.passengers[index]?.lnamefa?.message
                            }
                          />
                        </div>
                      </DataTableRow> */}
                      <DataTableRow>
                        <div className="form-control-wrap">
                          <input
                            type="text"
                            className="form-control-lg form-control"
                            {...register(`passengers[${index}].fnameen`)}
                          />
                          <ErrorMessage
                            message={
                              errors.passengers &&
                              errors.passengers[index]?.fnameen?.message
                            }
                          />
                        </div>
                      </DataTableRow>
                      <DataTableRow>
                        <div className="form-control-wrap">
                          <input
                            type="text"
                            className="form-control-lg form-control"
                            {...register(`passengers[${index}].lnameen`)}
                          />
                          <ErrorMessage
                            message={
                              errors.passengers &&
                              errors.passengers[index]?.lnameen?.message
                            }
                          />
                        </div>
                      </DataTableRow>
                      <DataTableRow>
                        <div className="form-control-wrap">
                          <input
                            type="text"
                            className="form-control-lg form-control"
                            {...register(`passengers[${index}].passengerCode`)}
                          />
                          <ErrorMessage
                            message={
                              errors.passengers &&
                              errors.passengers[index]?.passengerCode?.message
                            }
                          />
                        </div>
                      </DataTableRow>
                      <DataTableRow>
                        <ConvertCurrency price={_item.price} />
                      </DataTableRow>
                      <DataTableRow className="nk-tb-col-tools">
                        <ul className="nk-tb-actions gx-1">
                          {index > 0 && (
                            <li onClick={() => handleRemovePassenger(index)}>
                              <Tooltip
                                tag="a"
                                containerClassName="btn btn-trigger btn-icon text-danger"
                                id={"delete" + index}
                                icon="trash-fill"
                                direction="top"
                                text="حذف"
                              />
                            </li>
                          )}
                        </ul>
                      </DataTableRow>
                    </DataTableItem>
                  ))}
              </DataTableBody>
              <div className="card-inner">
                {isEmpty(watch("passengers")) && (
                  <div className="text-center">
                    <span className="text-silent">
                      مسافری برای نمایش یافت نشد
                    </span>
                  </div>
                )}
              </div>
            </DataTable>
          </div>

          <br />
          <Row className="gy-4 align-items-end">
            <Col md="6" xxl="4">
              <FormGroup>
                <label className="form-label" htmlFor="mobile">
                  موبایل مسافر
                </label>
                <div className="form-control-wrap">
                  <input
                    type="text"
                    placeholder="موبایل مسافر را وارد نمایید"
                    className="form-control-lg form-control"
                    {...register("mobile")}
                  />
                  <ErrorMessage message={errors.mobile?.message} />
                </div>
              </FormGroup>
            </Col>
            <Col md="6" xxl="4">
              <FormGroup>
                <label className="form-label" htmlFor="email">
                  ایمیل مسافر
                </label>
                <div className="form-control-wrap">
                  <input
                    type="email"
                    placeholder="ایمیل مسافر را وارد نمایید"
                    className="form-control-lg form-control"
                    {...register("email")}
                  />
                  <ErrorMessage message={errors.email?.message} />
                </div>
              </FormGroup>
            </Col>
            <Col md="6" xxl="4">
              <FormGroup>
                <label className="form-label" htmlFor="captchcode">
                  کد تصویر
                </label>
                <div className="form-control-wrap input-group">
                  <span className="input-group-append form-control-lg form-control p-0">
                    <img
                      src={flight.link_captcha}
                      className="w-100 h-100"
                      alt=""
                    />
                  </span>
                  <input
                    type="text"
                    placeholder="کد تصویر را وارد نمایید"
                    className="form-control-lg form-control"
                    {...register("captchcode")}
                  />
                  <ErrorMessage message={errors.captchcode?.message} />
                </div>
              </FormGroup>
            </Col>
          </Row>
          <br />
          <Alert color="primary" className="text-center">
            مبلغ قابل پرداخت:
            <ConvertCurrency
              price={watch("passengers")?.reduce(
                (prev, current) => (prev += current.price),
                0
              )}
            />
            <Currency />
          </Alert>
          <div className="text-right mt-3">
            <Button color="success" className="px-5" size="lg" loading={loader}>
              رزرو
            </Button>
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
};
